import { render } from "./PendingJobUpdates.vue?vue&type=template&id=2a8d6832"
import script from "./PendingJobUpdates.vue?vue&type=script&lang=js"
export * from "./PendingJobUpdates.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__